<template>
  <div class="proyects-list">
    <div
      class="card greenBlue proyects-item"
      v-for="item in data"
      :key="item.index"
      @click="selectProject(item.key,item.nombre)"
    >
      <div class="row align-items-center">
        <div class="col-auto proyects-icon">
          <div class="icon-container">
            <svg viewBox="0 0 25 23">
              <path
                id="Rectángulo_redondeado_839"
                data-name="Rectángulo redondeado 839"
                d="M41,355H54a5,5,0,0,1,5,5v13c0,2.762-.092,3.168,2,5H41a5,5,0,0,1-5-5V360A5,5,0,0,1,41,355Z"
                transform="translate(-36 -355)"
                fill="#00b99e"
              />
            </svg>
          </div>
        </div>
        <div class="col">
          <div class="proyect-description" @click="() => { goTo(item.key)}">
            <h1>{{ item.nombre }}</h1>
            <p>Creado el {{ getDate(item.created) }}</p>
          </div>
        </div>
        <div class="col-auto dropdown-action">
          <div class="dropdown">
            <button class="dropdown-trigger">
              <span class="more-button"></span>
              <span class="more-button"></span>
              <span class="more-button"></span>
            </button>
            <div class="dropdown-option">
              <ul>
                <li @click="() => { goTo(item.key)}">Ver</li>
                <li>Editar</li>
                <li>Eliminar</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="button-circle-more secondary">
      <button class="circle-more">
        <svg viewBox="0 0 18 18">
          <g id="Grupo_29" data-name="Grupo 29" transform="translate(-171 -753)">
            <rect
              id="Rectángulo_redondeado_903"
              data-name="Rectángulo redondeado 903"
              width="2"
              height="18"
              rx="1"
              transform="translate(179 753)"
              fill="#fff"
            />
            <rect
              id="Rectángulo_redondeado_903_copia"
              data-name="Rectángulo redondeado 903 copia"
              width="18"
              height="2"
              rx="1"
              transform="translate(171 761)"
              fill="#fff"
            />
          </g>
        </svg>
      </button>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
import { bus } from "../bus";
export default {
  name: "projectlistchose",
  components: {},
  data: () => ({
    data: []
  }),
  props: ["newproject"],
  watch: {
    newproject: function(newVal, oldVal) {
      // watch it
      if (newVal != null) {
        this.data.unshift(newVal);
      }
    }
  },
  computed:{
    token(){
      return this.$store.getters.getToken;
    }
  },
  methods: {
    selectProject(key, nombre) {
      let data = {
        key: key,
        nombre: nombre
      };
      bus.$emit("projectChose", data);
    },
    goTo(key) {},
    getDate(date) {
      let d = new Date(date);
      let day = d.getDate();
      let month = d.getMonth() + 1;
      let year = d.getFullYear();

      return day + "/" + month + "/" + year;
    },
    getList() {
      var that = this;
      var dat = JSON.stringify({
        token: this.token,
        providerID: this.$store.state.userInfo.net,
        limit: 10
      });
      axios
        .post(
          that.url + "getDashboards",
          dat
        )
        .then(function(response) {
          console.log(response.data);
          that.data = response.data.result;
        })
        .catch(function(error) {
          console.log("Error");
          console.log(error);
        });
    }
  },
  beforeMount() {
    this.getList();
  }
};
</script>

<style lang="scss">
.proyects-item:hover {
  cursor: pointer;
}
</style>
